let downloadFile = {
  inserted(el, binding) {
    let { url, fileName } = binding.value;//获取参数
    el.addEventListener('click', () => {
      let x = new XMLHttpRequest();
      x.open("GET", url, true);
      x.responseType = 'blob';
      x.onload = function (e) {
        let url = window.URL.createObjectURL(x.response)
        let a = document.createElement('a');
        a.href = url
        if (fileName != null && fileName != "") {
          a.download = fileName;
        }
        a.click()
      }
      x.send();
    })
  }
}
// 不污染原有方法，添加一个
export const downloadFile2 = function (url, fileName) {
  let x = new XMLHttpRequest();
  x.open("GET", url, true);
  x.responseType = 'blob';
  x.onload = function (e) {
    let url = window.URL.createObjectURL(x.response)
    let a = document.createElement('a');
    a.href = url
    if (fileName != null && fileName != "") {
      a.download = fileName;
    }
    a.click()
  }
  x.send();
}
export default downloadFile



// WEBPACK FOOTER //
// ./src/directives/src/downloadFile.js